import React from 'react'
import PropTypes from 'prop-types'
import BEM from '@iui-kit/utils/bem'
import styles from './Checkbox.css'

const bem = new BEM(styles)

const Checkbox = ({
  name,
  onChange,
  onBlur,
  disabled,
  checked,
  children,
  className,
  isValid,
  ...other
}) => {
  let hasChildren = true

  if (children === undefined || children === null || children === '') {
    hasChildren = false
  }
  return (
    <>
      <label
        className={bem
          .b('checkbox')
          .m('disabled', disabled)
          .m('hasChildren', hasChildren)
          .m('invalid', !isValid)
          .mix(className)
          .show()}
      >
        <input
          {...other}
          type="checkbox"
          className={bem
            .b('checkbox')
            .e('input')
            .show()}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          checked={checked}
          disabled={disabled}
        />
        <span
          className={bem
            .b('checkbox')
            .e('indicator')
            .show()}
        />
        {children}
      </label>
    </>
  )
}

Checkbox.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
}

Checkbox.defaultProps = {
  disabled: false,
  children: null,
  className: null
}

export default Checkbox
